export const TextView = () => null;
